import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
var __jsx = React.createElement;
import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { useStore } from "@dp/state";
import { observer } from "mobx-react-lite";
import { ORDER_TYPES } from "@dp/common";
import Head from "next/head";
import { PageLayout } from "../../util/constants";
var MenuDetail = dynamic(function () {
  return import("@dp/xcomp").then(function (mod) {
    return mod.MenuItemDetails;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@dp/xcomp")];
    }
  }
});
var MenuListing = dynamic(function () {
  return import("@dp/xcomp").then(function (mod) {
    return mod.MenuListing;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@dp/xcomp")];
    }
  }
});
function _getSlugs(pathWithQueryParams) {
  var slugs = [];
  var queryParams = "";
  var effectivePath = pathWithQueryParams.replace("/menu", "");
  if (effectivePath.indexOf("?") !== -1) {
    var _effectivePath$split = effectivePath.split("?"),
      _effectivePath$split2 = _slicedToArray(_effectivePath$split, 2),
      _slugs = _effectivePath$split2[0],
      _query = _effectivePath$split2[1];
    slugs = _slugs.split("/");
    queryParams = _query.length && "?".concat(_query);
  } else {
    slugs = effectivePath.split("/");
  }
  return {
    slugs: slugs.filter(function (f) {
      return f.length > 0;
    }),
    queryParams: queryParams
  };
}
var MenuRoutePage = function MenuRoutePage(_ref) {
  var _store$menuList, _store$menuList2, _store$menuList3, _store$menuList4, _store$menuList5, _store$menuList6, _store$menuList7, _store$menuList8, _store$menuList18;
  var brand = _ref.brand;
  var router = useRouter(); // ["foo", "bar"]
  var _useState = useState(false),
    componentInitialized = _useState[0],
    setComponentInitialized = _useState[1];
  var _useState2 = useState(true),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var store = useStore();
  var lastSlug = null;
  var _getSlugs2 = _getSlugs(router.asPath),
    slug = _getSlugs2.slugs,
    queryParams = _getSlugs2.queryParams;
  var menuList = store === null || store === void 0 || (_store$menuList = store.menuList) === null || _store$menuList === void 0 ? void 0 : _store$menuList.menuList;
  if (slug !== null && (slug === null || slug === void 0 ? void 0 : slug.length) >= 2) lastSlug = slug.pop();
  var slugClassifier = lastSlug && menuList ? store === null || store === void 0 || (_store$menuList2 = store.menuList) === null || _store$menuList2 === void 0 ? void 0 : _store$menuList2.isMenuOrSubCategory(lastSlug) : null;
  var categories = store === null || store === void 0 || (_store$menuList3 = store.menuList) === null || _store$menuList3 === void 0 || (_store$menuList3 = _store$menuList3.menuListModel) === null || _store$menuList3 === void 0 || (_store$menuList3 = _store$menuList3.menuListData) === null || _store$menuList3 === void 0 ? void 0 : _store$menuList3.categories;
  var orderType = store === null || store === void 0 || (_store$menuList4 = store.menuList) === null || _store$menuList4 === void 0 || (_store$menuList4 = _store$menuList4.menuListModel) === null || _store$menuList4 === void 0 ? void 0 : _store$menuList4.orderType;
  var defaultCategoryCode = store === null || store === void 0 || (_store$menuList5 = store.menuList) === null || _store$menuList5 === void 0 || (_store$menuList5 = _store$menuList5.menuListModel) === null || _store$menuList5 === void 0 ? void 0 : _store$menuList5.defaultCategoryCode;
  var currentCategoryCode = store === null || store === void 0 || (_store$menuList6 = store.menuList) === null || _store$menuList6 === void 0 || (_store$menuList6 = _store$menuList6.menuListModel) === null || _store$menuList6 === void 0 ? void 0 : _store$menuList6.currentCategoryCode;
  var brandCode = store === null || store === void 0 || (_store$menuList7 = store.menuList) === null || _store$menuList7 === void 0 || (_store$menuList7 = _store$menuList7.appAttributes) === null || _store$menuList7 === void 0 || (_store$menuList7 = _store$menuList7.concept) === null || _store$menuList7 === void 0 ? void 0 : _store$menuList7.conceptCodeDesc;
  var menuItem = store === null || store === void 0 || (_store$menuList8 = store.menuList) === null || _store$menuList8 === void 0 || (_store$menuList8 = _store$menuList8.menuDetailModel) === null || _store$menuList8 === void 0 ? void 0 : _store$menuList8.menuItem;
  var restaurantNum = router.query.setRestaurant;
  var menuListStore = store === null || store === void 0 ? void 0 : store.menuList;
  var orderTypeFromUrl = router.query.orderType;
  var restNum = router.query.restaurantNum;
  var visitId = router.query.visitId;
  var source = router.query.source;
  var kind = router.query.kind;
  var getPageTilte = function getPageTilte(_currentCategoryCode) {
    if (_currentCategoryCode) {
      var itemName = _currentCategoryCode.split("-").join(" ").toUpperCase();
      return "".concat(itemName, " | Menu | ").concat(brandCode);
    }
    return "Menu";
  };
  var getMenuDetailPageTilte = function getMenuDetailPageTilte() {
    if (menuItem !== null && menuItem !== void 0 && menuItem.name) {
      var categoryCode = (menuItem === null || menuItem === void 0 ? void 0 : menuItem.breadCrumbSlug.split("/")[0]) || "";
      var splitCategoryName = categoryCode.split("-").join(" ");
      var category = splitCategoryName.charAt(0).toUpperCase() + splitCategoryName.slice(1);
      return "".concat(menuItem === null || menuItem === void 0 ? void 0 : menuItem.name, " | ").concat(category, " | ").concat(brandCode);
    }
    return "Menu Item";
  };
  useEffect(function () {
    var abTestHandler = function abTestHandler() {
      var _store$menuList9;
      var isMenuSearchDisabled = window["WEB_MENU_SEARCH_DISABLE"] || false;
      store === null || store === void 0 || (_store$menuList9 = store.menuList) === null || _store$menuList9 === void 0 || (_store$menuList9 = _store$menuList9.searchModel) === null || _store$menuList9 === void 0 || _store$menuList9.setMenuSearchABTest(isMenuSearchDisabled);
    };
    window.addEventListener("ABTestEvent", abTestHandler);
    return function () {
      window.removeEventListener("ABTestEvent", function () {
        return abTestHandler;
      });
    };
  }, []);
  useEffect(function () {
    var handleRouteChange = function handleRouteChange(url, _ref2) {
      var shallow = _ref2.shallow;
      try {
        var _store$menuList0, _store$menuList1, _store$menuList10, _store$menuList11, _store$menuList12, _store$menuList13;
        if (!(store !== null && store !== void 0 && (_store$menuList0 = store.menuList) !== null && _store$menuList0 !== void 0 && _store$menuList0.isLocationSelectionMandatory)) {
          store.menuList.orderSettingsModel.showRestaurantSearchModal = false;
        }
        if (store !== null && store !== void 0 && (_store$menuList1 = store.menuList) !== null && _store$menuList1 !== void 0 && (_store$menuList1 = _store$menuList1.searchModel) !== null && _store$menuList1 !== void 0 && _store$menuList1.showSearchModal) {
          var _store$platformUtil;
          /**
           * nav added because if already visited PDP via search
           * and came back using View Menu CTA
           * that route remain in history and then clicking on browser back opens PDP
           **/
          store === null || store === void 0 || (_store$platformUtil = store.platformUtil) === null || _store$platformUtil === void 0 || _store$platformUtil.navigateToRoute("/menu");
          store.menuList.searchModel.showSearchModal = false;
          store.menuList.searchModel.searchInputBoxText = "";
          store.menuList.searchModel.searchText = "";
        }
        store === null || store === void 0 || (_store$menuList10 = store.menuList) === null || _store$menuList10 === void 0 || (_store$menuList10 = _store$menuList10.menuListModel) === null || _store$menuList10 === void 0 || _store$menuList10.toggleShowQuickAddMenuCustomizationModal(false);
        store === null || store === void 0 || (_store$menuList11 = store.menuList) === null || _store$menuList11 === void 0 || (_store$menuList11 = _store$menuList11.menuListModel) === null || _store$menuList11 === void 0 || _store$menuList11.setCurrentAddToCartLoadingItemID(null);
        store === null || store === void 0 || (_store$menuList12 = store.menuList) === null || _store$menuList12 === void 0 || _store$menuList12.cartModel.setIsAddToCartLoading(false);
        store === null || store === void 0 || (_store$menuList13 = store.menuList) === null || _store$menuList13 === void 0 || (_store$menuList13 = _store$menuList13.cartModel) === null || _store$menuList13 === void 0 || _store$menuList13.toggleEditMenuCustomizationModal(false);
        store.menuList.orderSettingsModel.showOrderSettingsConfirmationModal = false;
      } catch (e) {
        console.log(e);
      }
    };
    router.events.on("routeChangeStart", handleRouteChange);
    return function () {
      router.events.off("routeChangeStart", handleRouteChange);
    };
  }, []);
  useEffect(function () {
    var _store$menuList14, _store$menuList15, _store$menuList16, _store$menuList17;
    if (store !== null && store !== void 0 && (_store$menuList14 = store.menuList) !== null && _store$menuList14 !== void 0 && _store$menuList14.isLocationSelectionMandatory && !(store !== null && store !== void 0 && (_store$menuList15 = store.menuList) !== null && _store$menuList15 !== void 0 && _store$menuList15.escapeLocationSelectionForDIPO)) {
      store.menuList.orderSettingsModel.showRestaurantSearchModal = true;
    } else if (store !== null && store !== void 0 && (_store$menuList16 = store.menuList) !== null && _store$menuList16 !== void 0 && _store$menuList16.orderSettingsModel && !(store !== null && store !== void 0 && (_store$menuList17 = store.menuList) !== null && _store$menuList17 !== void 0 && _store$menuList17.isLocationSelectionMandatory)) {
      store.menuList.orderSettingsModel.showRestaurantSearchModal = false;
    }
  }, [store === null || store === void 0 || (_store$menuList18 = store.menuList) === null || _store$menuList18 === void 0 ? void 0 : _store$menuList18.isLocationSelectionMandatory]);
  useEffect(function () {
    if (restaurantNum && menuListStore) {
      menuListStore.selectRestaurant(restaurantNum);
    }
  }, [restaurantNum, menuListStore]);
  useEffect(function () {
    if (orderTypeFromUrl === "dinein" && restNum) {
      var _store$dineInOrder;
      store === null || store === void 0 || (_store$dineInOrder = store.dineInOrder) === null || _store$dineInOrder === void 0 || _store$dineInOrder.initiateDineInOrder(restNum, visitId, source, kind);
    }
  }, [orderTypeFromUrl, restNum, menuListStore]);
  useEffect(function () {
    //if (!router.isReady) return;
    store.initComponent("Menu").then(function () {
      setComponentInitialized(true);
    });
  }, []);
  useEffect(function () {
    if (componentInitialized) {
      if (!lastSlug || menuList) {
        setLoading(false);
      }
    }
  }, [componentInitialized, lastSlug, menuList]);
  useEffect(function () {
    var catering = categories === null || categories === void 0 ? void 0 : categories.find(function (_c) {
      return _c.code === "catering";
    });
    if (slug.length || !categories || !categories.length) return;
    if ((orderType === ORDER_TYPES.CATERING_DELIVERY || orderType === ORDER_TYPES.CATERING_PICKUP) && catering) {
      router.push("/menu/".concat(catering.code, "/").concat(queryParams));
    } else {
      var _categories$;
      defaultCategoryCode ? router.push("/menu/".concat(defaultCategoryCode, "/").concat(queryParams)) : router.push("/menu/".concat(categories === null || categories === void 0 || (_categories$ = categories[0]) === null || _categories$ === void 0 ? void 0 : _categories$.code, "/").concat(queryParams));
    }
  }, [categories, orderType, slug, defaultCategoryCode]);

  // eslint-disable-next-line sonarjs/cognitive-complexity
  var getComp = function getComp() {
    var _getSlugs3 = _getSlugs(router.asPath),
      slug = _getSlugs3.slugs,
      queryParams = _getSlugs3.queryParams;
    if (slug === null) {
      return __jsx(React.Fragment, null, __jsx(Head, null, __jsx("title", null, "Menu"), __jsx("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=no"
      })), __jsx(MenuListing, {
        name: "Menu",
        queryParmas: queryParams
      }));
    } else if ((slug === null || slug === void 0 ? void 0 : slug.length) === 1) {
      return __jsx(React.Fragment, null, __jsx(Head, null, __jsx("title", null, getPageTilte(currentCategoryCode)), __jsx("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=no"
      })), __jsx(MenuListing, {
        name: "Menu",
        anchorSlug: slug.join("/"),
        queryParmas: queryParams
      }));
    } else if ((slug === null || slug === void 0 ? void 0 : slug.length) === 2 && slugClassifier) {
      if (slugClassifier === "MENU") {
        return __jsx(React.Fragment, null, __jsx(Head, null, __jsx("title", null, getMenuDetailPageTilte()), menuItem !== null && menuItem !== void 0 && menuItem.seoMetaDescription ? __jsx("meta", {
          name: "description",
          content: menuItem === null || menuItem === void 0 ? void 0 : menuItem.seoMetaDescription
        }) : null, __jsx("meta", {
          name: "viewport",
          content: "width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=no"
        })), __jsx(MenuDetail, {
          name: "Menu",
          menuId: slug[1],
          category: slug[0]
        }));
      } else if (slugClassifier === "CATEGORY") {
        return __jsx(React.Fragment, null, __jsx(Head, null, __jsx("title", null, getPageTilte(currentCategoryCode)), __jsx("meta", {
          name: "viewport",
          content: "width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=no"
        })), __jsx(MenuListing, {
          name: "Menu",
          anchorSlug: slug.join("/"),
          queryParmas: queryParams
        }));
      } else {
        return __jsx(MenuListing, {
          name: "Menu",
          queryParmas: queryParams
        }); //TODO: may be show a 404 page here since the slug was not found
      }
    } else if ((slug === null || slug === void 0 ? void 0 : slug.length) === 3) {
      if (slugClassifier === "MENU") {
        return __jsx(React.Fragment, null, __jsx(Head, null, __jsx("title", null, getMenuDetailPageTilte()), menuItem !== null && menuItem !== void 0 && menuItem.seoMetaDescription ? __jsx("meta", {
          name: "description",
          content: menuItem === null || menuItem === void 0 ? void 0 : menuItem.seoMetaDescription
        }) : null, __jsx("meta", {
          name: "viewport",
          content: "width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=no"
        })), __jsx(MenuDetail, {
          name: "Menu",
          menuId: slug[2],
          category: slug[0],
          subCategory: slug[1]
        }));
      } else {
        return __jsx(React.Fragment, null, __jsx(Head, null, __jsx("title", null, getPageTilte(currentCategoryCode)), __jsx("meta", {
          name: "viewport",
          content: "width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=no"
        })), __jsx(MenuListing, {
          name: "Menu",
          queryParmas: queryParams
        }), ";");
      }
    }
    return __jsx(MenuListing, {
      name: "Menu",
      queryParmas: queryParams
    });
  };
  if (loading) {
    return __jsx("div", {
      style: {
        height: "100vh"
      }
    });
    // return <></>;
  } else {
    return __jsx(React.Fragment, null, getComp());
  }
};
MenuRoutePage["layout"] = PageLayout.NB_LAYOUT;
export default observer(MenuRoutePage);